import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import MonacoEditor from '@monaco-editor/react';
import React, { useCallback } from 'react';

type Props = {
    isOpen: boolean;
    onClose: () => void;

    selectedFileContent: string;
}

function ModalDetailScriptFile(props: Props) {
    const {
        isOpen,
        onClose,
        selectedFileContent
    } = props;

    const handleClose = useCallback(() => {
        // Clean-up states

        onClose();
    }, [onClose]);

    return (
        <Modal
            isCentered
            size="6xl"
            isOpen={isOpen}
            onClose={handleClose}
            closeOnOverlayClick={false}
            scrollBehavior="inside"
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader className="border-b-2">Migration Script Content</ModalHeader>
                <ModalCloseButton className="border hover:bg-red-300" />
                <ModalBody>
                    <div className="flex flex-1 flex-col gap-2 pl-4 h-[600px]"> {/* ระบุความสูง modal body */}
                        <div className="flex-1">
                            <MonacoEditor
                                language="sql"
                                theme="vs-light"
                                value={selectedFileContent}
                                options={{ selectOnLineNumbers: true }}
                                height="100%"
                                className="w-full"
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter />
            </ModalContent>
        </Modal >
    )
}

export default ModalDetailScriptFile;